export const THEME_STORAGE_KEY = 'ageinformatica-theme';

export function normalizeTheme(value) {
  return value === 'dark' ? 'dark' : 'light';
}

export function getStoredTheme() {
  try {
    return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return 'light';
  }
}

export function applyTheme(theme) {
  const normalized = normalizeTheme(theme);
  document.documentElement.dataset.theme = normalized;
  document.documentElement.style.colorScheme = normalized;
  return normalized;
}

export function saveTheme(theme) {
  const normalized = applyTheme(theme);
  try { localStorage.setItem(THEME_STORAGE_KEY, normalized); } catch {}
  return normalized;
}

export function clearStoragePreservingTheme() {
  const theme = getStoredTheme();
  localStorage.clear();
  try { localStorage.setItem(THEME_STORAGE_KEY, theme); } catch {}
}
